module.exports = __webpack_public_path__ + "img/bg-right.31e8e061.png";